import * as API from "@/services/API";

export default {
  getMain(Id) {
    return API.apiClient.get(`/amain/${Id}`);
  },
  getMains() {
    return API.apiClient.get(`/amain/`);
  },
  postMain(payload) {
    return API.apiClient.post(`/amain/`, payload);
  },
  updateMain(Id, payload) {
    return API.apiClient.put(`/amain/${Id}`, payload);
  },
  deleteMain(Id) {
    return API.apiClient.delete(`/amain/${Id}`);
  },
};
